interface Operation {
    start: number;
    delete_count: number;
    insert_lines: string[];
}

function applyDiff(root: string, diff: string): string {
    const rootLines = ["", ...root.split("\n")]; // prepend with empty string - unified diff starts indexing at 1

    // remove leading whitespace from all lines
    const diffLines = diff.split("\n");
    const processedDiff = diffLines.join("\n");

    const firstHunkIndex = processedDiff.indexOf("@@");
    if (firstHunkIndex === -1) {
        return root;
    }
    const hunksString = processedDiff.substring(firstHunkIndex);

    const hunkStrings = hunksString.split(/\n(?=@@)/);

    const operations: Operation[] = [];

    for (const hunkStr of hunkStrings) {
        const lines = hunkStr.split("\n");
        const header = lines[0];

        const match = header.match(/@@ -(\d+)(?:,(\d+))? \+(\d+)(?:,(\d+))? @@/);

        if (!match) {
            throw new Error("Invalid hunk header in diff");
        }

        const oldStart = parseInt(match[1], 10);
        const oldCount = match[2] ? parseInt(match[2], 10) : 1;
        const newStart = parseInt(match[3], 10);
        const newCount = match[4] ? parseInt(match[4], 10) : 1;

        // Parse the actual diff lines
        const deletions: string[] = [];
        const additions: string[] = [];

        for (const line of lines.slice(1)) {
            if (!line) {
                // Truly empty line in the diff itself
                continue;
            }

            const prefix = line[0];

            // SKIP METADATA LINES (like "\ No newline at end of file")
            if (prefix === "\\") {
                continue;
            }

            const content = line.length > 1 ? line.substring(1) : "";

            if (prefix === "-") {
                // Deletion
                deletions.push(content);
            } else if (prefix === "+") {
                // Addition
                additions.push(content);
            } else if (prefix === " ") {
                // Context line (unchanged) - this includes blank lines with " " prefix
                deletions.push(content);
                additions.push(content);
            } else {
                // Line without proper prefix - treat as context
                deletions.push(line);
                additions.push(line);
            }
        }

        // Validate counts match what we parsed
        // (In a real parser you'd be more strict, but for now just use what we got)

        // The operation replaces lines [old_start : old_start + old_count]
        // with the additions
        // Special case: if old_count is 0, we're inserting after old_start
        if (oldCount === 0) {
            // Insert after line old_start (appending)
            operations.push({
                start: oldStart,
                delete_count: 0,
                insert_lines: additions,
            });
        } else {
            operations.push({
                start: oldStart,
                delete_count: oldCount,
                insert_lines: additions,
            });
        }
    }

    // Apply operations in reverse order to maintain line numbers
    operations.sort((a, b) => b.start - a.start);

    for (const op of operations) {
        if (op.delete_count === 0) {
            // Insert after the start line
            rootLines.splice(op.start + 1, 0, ...op.insert_lines);
        } else {
            // Replace lines
            rootLines.splice(op.start, op.delete_count, ...op.insert_lines);
        }
    }

    return rootLines.slice(1).join("\n");
}
export function applyDiffs(root: string, diffs: string[]): string {
    let result = root;
    for (const diff of diffs) {
        result = applyDiff(result, diff);
    }
    return result;
}
